/**
 * Branding in one place. The product name is a working name (PRD Q2 open); when it is
 * decided, change this file (and public/icons, manifest.webmanifest, index.html meta —
 * see docs/DESIGN.md "Rebranding"). Nothing else in the app hard-codes the name.
 * The organisation's own name and logo come from the session (each client is a tenant).
 */
export const BRAND = {
  /** Product name shown in the sidebar, sign-in and title bar. */
  product: 'NotaVera',
  /** Short form for tight spots (installed app name, collapsed sidebar). */
  short: 'NotaVera',
  /** One line under the wordmark on the sign-in screen. */
  tagline: 'Electronic notarization, built to the Supreme Court Rules',
  /** Optional product logo (served from /public). Empty = the catalogue-drawer wordmark. */
  logoUrl: '' as string,
  /** Who runs the service, for the footer and Help. */
  operator: 'ITCORE Solutions Inc.',
  supportEmail: 'support@itcore-apps.com',
  /** Browser tab title suffix: "Search – NotaVera". */
  titleSuffix: 'NotaVera',
} as const;

export const pageTitle = (title?: string): string => (title ? `${title} – ${BRAND.titleSuffix}` : BRAND.titleSuffix);
